
import { API_PATH, LOGIN,ADMIN_LOGIN  } from './const';
import { axiosApi } from './axiosAPI';
import { ERROR_MESSAGE } from './model/errorMessage';

const RESOURCE_LOGIN = API_PATH + "/resources/login";

//セッションチェック
export const getSessionInfo = () =>{
    axiosApi
      .get(RESOURCE_LOGIN)
      .then((response) =>{
            //ログイン済みの時
      })
      .catch((error) =>{
          if (error.response){
            //通信時のエラー
            const _statusCode = error.response.status;
            if (_statusCode){
                //ログインしていない場合
                window.location.href = LOGIN;
            }else{
                //通信失敗
                window.location.href = LOGIN;
            }
          }
          else{
              //それ以外のエラー
              window.location.href = LOGIN;
          }
      })
  }

//一般権限用のセッションチェック
export const getSessionInfoGeneral = () =>{
    axiosApi
      .get(RESOURCE_LOGIN)
      .then((response) =>{
            //ログイン済みの場合
            const _responseData = response.data;
            const _authority = _responseData.authority;

            //authority 0:一般、1:管理者
            if (_authority === "1"){
                //一般権限でない場合、セッション切断してログイン画面へ遷移
                this.killSessionLoginInfo();
                window.location.href = LOGIN;
            }
      })
      .catch((error) =>{
          if(error.response){
            //通信でのエラー
            const _statusCode = error.response.status;
            if(_statusCode){
                //ログインしていない場合、一般のログイン画面へ遷移
                window.location.href = LOGIN;
            }else{
                window.location.href = LOGIN;            
            }
          }else{
              //レスポンス取得後のエラー or 通信失敗
              window.location.href = LOGIN;  
          }

      })
  }

//Admin権限用のセッションチェック
export const getSessionInfoAdmin = () =>{
axiosApi
    .get(RESOURCE_LOGIN)
    .then((response) =>{
        //ログイン済みの場合
        const _responseData = response.data;
        const _authority = _responseData.authority;
        //authority 0:一般、1:管理者
        if (_authority === "0"){
            //管理者権限でない場合、セッション切ってログイン画面へ遷移
            this.killSessionLoginInfo();
            window.location.href = LOGIN;
        }
    })
    .catch((error) =>{
        if(error.response){
            //通信でのエラー
            const _statusCode = error.response.status;
            if (_statusCode){
                //ログインしていない場合、管理者のログイン画面へ遷移
                window.location.href = LOGIN;            
            }else{
                //入らない処理
                window.location.href = LOGIN;
            }
        }else{
            //レスポンス取得後のエラー or 通信失敗
            window.location.href = LOGIN;
        }
    })
}

//ログアウト処理
export const killSessionLoginInfo = () =>{
    axiosApi
        .delete(RESOURCE_LOGIN)
        .then(() => {
        })
        .catch((error) => {
            if(error.response){
                console.log(error.response)
                //通信時のエラー
                const _statusCode = error.response.status;
                if (_statusCode){
                    //Forbidden
                    //セッション切れてるからok
                }else{
                    alert("サーバーとの接続に失敗しました。");
                }
            }else{
                //レスポンス取得後のエラー
                alert("想定外のエラーが発生しました。");
            }
        })
}

//入力エラー時のメッセージ作成
export const createErrorMessage = (errrorData) =>{
//日本語のメッセージ格納用オブジェクト
let errorMessageArray = [{}];

if(Array.isArray(errrorData)){
    //日本語のメッセージを入れて返却
    errrorData.forEach(data => {
        errorMessageArray.push({
            name:data.name,
            message:ERROR_MESSAGE.find(_errorMessage =>_errorMessage.error === data.error).message
        });
    });
}else{
    errorMessageArray.push({
        name:errrorData.name,
        message:ERROR_MESSAGE.find(_errorMessage =>_errorMessage.error === errrorData.error).message
    });
}

//先頭の空データを削除
errorMessageArray.shift();

//htmlにエラーメッセージを埋め込み
errorMessageArray.forEach(_errorMessage => {
    //エラーメッセージ要素を作成
    let _errorMessageElement = document.createElement('div');
    _errorMessageElement.textContent = _errorMessage.message;
    _errorMessageElement.className = "errorMessage";

    //エラーメッセージ要素を追加するFormGroup
    const errorTargetElement = document.getElementsByClassName(_errorMessage.name).item(0);
    //エラーメッセージ要素を追加するlabel
    let messageDisplayArea = errorTargetElement.firstElementChild;
    messageDisplayArea.appendChild(_errorMessageElement);
});
}


//画面に表示されているエラーメッセージ要素を削除
export const removeErrorMessageElement = () =>{
    let existingErrorMessage = document.getElementsByClassName("errorMessage");
    while(existingErrorMessage.length){
        //IE対応処理
        //existingErrorMessage.item(0).remove();
        existingErrorMessage.item(0).parentNode.removeChild(existingErrorMessage.item(0));
    };
}

